import mergeWith from "lodash.mergewith";

const initialState = {
    users: {},
    artists: {},
    spaces: {},
    blog: {},
	spaceReservations: {}
};

export default function entities(state = initialState, action) {
    if (action.payload && action.payload.entities) {
        return mergeWith({}, state, action.payload.entities, (_, srcValue) => {
            if (Array.isArray(srcValue)) {
                return srcValue;
            }

            return undefined;
        });
    }

    switch (action.type) {
        default:
            return state;
    }
}
